import styled from "styled-components";

const Message = styled.div`
`;

export default function ProductCategoryListEmpty(){
    return (
        <Message>Category list is empty. It's may be a error!</Message>
    )
}